import React from "react";

const BasicInfo = ({ selectedEscrow }) => {
  return (
    <div className="pt-3">
      {[
        ["Registered company name", selectedEscrow.registered_company_name],
        ["PAN", selectedEscrow.pan || "N/A"],
        ["GST", selectedEscrow.gst || "N/A"],
        ["Purpose of escrow", selectedEscrow.purpose_of_escrow || "N/A"],
        [
          "Primary contact first name",
          selectedEscrow.primary_contact_first_name || "N/A",
        ],
        [
          "Primary contact last name",
          selectedEscrow.primary_contact_last_name || "N/A",
        ],
        [
          "Primary contact Email ID",
          selectedEscrow.primary_contact_email_id || "N/A",
        ],
        ["Phone number", selectedEscrow.phone_number || "N/A"],
        ["Virtual account number prefix", selectedEscrow.van_prefix || "N/A"],
        ["Main escrow ID", selectedEscrow.main_escrow_id || "N/A"],
        ["Sub escrow ID", selectedEscrow.sub_escrow_id || "N/A"],
      ].map(([label, value]) => (
        <div className="row mb-2 mb-4" key={label}>
          <div
            className="col-md-4 "
            style={{ fontWeight: "600", fontsize: "16px" }}
          >
            {label}
          </div>
          <div className="col-md-8">: {value || "N/A"}</div>
        </div>
      ))}
    </div>
  );
};

export default BasicInfo;
